import { scroll } from './locomotive';

const selectors = {
  contactFormWrapper: '.js-contact-form-section',
};

const handleContactForm = () => {
  const wrapper = document.querySelector(selectors.contactFormWrapper);

  if (wrapper === null) return;

  let prevBlockSize = 0;

  const resizeCallback = (entries) => {
    const [entry] = entries;
    const { contentBoxSize } = entry;
    const { blockSize } = contentBoxSize[0];

    if (blockSize === prevBlockSize) return;

    prevBlockSize = blockSize;

    scroll.update();
  };

  const observer = new ResizeObserver(resizeCallback);
  observer.observe(wrapper);
};

export default handleContactForm;
